import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import axios from 'axios';
import ImageResults from '../image-results/ImageResults';


const apiUrl = 'https://pixabay.com/api';
const apiKey = process.env.REACT_APP_PIXABAY_API_KEY;
const Search = () => {
	const [ state, setState ] = useState({
		searchText: '',
		amount: 15,
		images: []
	});
  
  const handleChange = (e) =>{
    const { name, value } = e.target; 
    setState((state) => ({ ...state, [name]: value }));
  }


  console.log(state.images);
  
  const search = (e) =>{
    if ((e.key === 'Enter')) {
    if (state.searchText === '') {
			setState((state) => ({ ...state, 'images': [] }));
		} else {
			axios
				.get(
					`${apiUrl}/?key=${apiKey}&q=${state.searchText}&image_type=photo&per_page=${state.amount}&safesearch=true`
				)
				.then((res) => setState({ images: res.data.hits }))
      	.catch((err) => console.log(err));
    }
  }
  }

	return (
    <React.Fragment>
		<div className="w-50 mx-auto mt-5">
      <TextField
          name="searchText"
          label ="《Enter》 to search"
					value={state.searchText}
					onChange={handleChange}
					fullWidth
          onKeyUp={search}
          style={{backgroundColor:'inherit'}}
				/>
			<br />
      <FormControl className="float-right">
        <Select
          labelId="amount"
          name="amount"
          value={state.amount}
          onChange={handleChange}
          style={{width:'150px'}}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      <br />
      <br />
    </div>
    <div> {state.images.length > 0 ? <ImageResults images={state.images} /> : null}</div>
    </React.Fragment>
	);
};

export default Search;
